import type { RouteType } from '$lib/components/route/types';
import * as m from '$paraglide/messages';

const routeBadgeLabel: Record<RouteType, () => string> = {
	economic: m.route__badge__economic,
	quickest: m.route__badge__quickest,
	ecological: m.route__badge__ecological,
	alternative: m.route__badge__alternative,
	shortest: m.route__badge__shortest,
	discovery: m.route__badge__discovery,
};

export function routeBadge(type: RouteType): string {
	return routeBadgeLabel[type]();
}
